import { toast } from "@/hooks/use-toast";

export function toastSuccess(message: string) {
  toast({
    title: message,
  });
}

export function toastError(message: string) {
  toast({
    title: message,
    variant: "destructive",
  });
}
